/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Addresses from './Addresses/index'
import BackAction from './BackAction/index'
import Details from './Details/index'
import Emails from './Emails/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Phones from './Phones/index'
import React from 'react'
import Relationship from './Relationship/index'
import SaveAction from './SaveAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/ViewDetails/Content"
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="View Details"
 level="h3"
/>
</div>
<Relationship
  viewPath={`${viewPath}/Relationship`}
/>
<Details
  viewPath={`${viewPath}/Details`}
/>
<Addresses
  viewPath={`${viewPath}/Addresses`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal1}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}